import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Alert, Row, Col, Select, Button, Modal, Switch, DatePicker } from 'antd';
import { withEventBus, withScreenLoader } from 'context';
import { ProductVariantSelector, parseSelectionCriteria } from 'components';
import * as productVariantSelector from 'redux/selectors/productVariant';
import * as productVariantActions from 'redux/actions/productVariant';
import * as productSelectors from 'redux/selectors/product';
import * as productActions from 'redux/actions/product';
import * as customerGroupActions from 'redux/actions/customerGroup';
import * as customerGroupSelector from 'redux/selectors/customerGroup';
import * as attributeSelectors from 'redux/selectors/attribute';
import * as attributeActions from 'redux/actions/attribute';
import * as homepageActions from 'redux/actions/homepage';
import {
  PRODUCT_VARIANT_SELECTION_COUNT_SUCCESS,
  PRODUCT_VARIANT_UPDATE_BULK_STATUS_SUCCESS
} from 'redux/actions/productVariant/action_types';
import { Autocomplete } from 'components';

import styles from './productStatusUpdate.module.less';

const confirm = Modal.confirm;

class ProductStatusUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      globalErrors: [],
      productId: 0,
      productName: ''
    };
    this.subscriptions = [];
    this.tagOption = null;
  }

  componentDidMount() {
    this.props.findAllCustGrp();
    this.props.loadAllPhoneBrands();
    this.subscriptions.push(
      this.props.eventBusSubscribe(PRODUCT_VARIANT_SELECTION_COUNT_SUCCESS, action => {
        this.props.hideScreenLoader();
        this.confirmChanges();
      })
    );
    this.subscriptions.push(
      this.props.eventBusSubscribe(PRODUCT_VARIANT_UPDATE_BULK_STATUS_SUCCESS, action => {
        this.props.setMessages({ successMsg: `Total of ${action.payload.updated} products status change.` });
        this.props.hideScreenLoader();
        this.props.history.push('/');
      })
    );
  }

  componentWillUnmount() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.props.unloadProduct();
    this.props.unloadCustGrp();
    this.props.unloadAttrs();
  }

  confirmChanges = () => {
    confirm({
      title: 'Do you want to update status?',
      content: `This action will update total of ${this.props.selectionCount} product. Do you want to continue?`,
      onOk: () => {
        this.props.showScreenLoader();
        this.parseFormAndCall(this.props.updateStatus);
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.parseFormAndCall(payload => {
      this.props.showScreenLoader();
      this.props.countSelection(payload.selectionCriteria);
    });
  };

  formatDate = date => (date ? date.format('YYYY-MM-DD') + 'T00:00:00.000Z' : null);

  formatEndDate = date => (date ? date.format('YYYY-MM-DD') + 'T23:59:59.000Z' : null);

  parseFormAndCall = cb => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values['price'] <= 0 && values['specialPrice'] <= 0 && !values['tierPrices']) {
          this.setState({
            globalErrors: ['Atleast 1 price type should be provided.']
          });
          return;
        }
        let payload = Object.assign({}, values, {
          tagStartDate: this.formatDate(values.tagStartDate),
          tagEndDate: this.formatEndDate(values.tagEndDate),
          newTo: this.formatDate(values.newTo)
        });
        parseSelectionCriteria(payload, this.props.attributes, this.state.productId);
        this.setState({
          globalErrors: []
        });
        cb(payload);
      }
    });
  };

  handleProductChange = (value, option) => {
    if (value && value.trim() !== '') {
      this.setState({
        productId: value,
        productName: option.children
      });
      this.props.loadAttrs(value);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={styles.productStatusUpdate}>
        <h2 className="page-title">
          Update Product Status{this.state.productName ? `: ${this.state.productName}` : ''}
        </h2>
        {this.state.globalErrors.length > 0 && (
          <Alert
            type="error"
            showIcon
            description={
              <ul>
                {this.state.globalErrors.map((e, idx) => (
                  <li key={idx}>{e}</li>
                ))}
              </ul>
            }
          />
        )}
        <Form onSubmit={this.handleSubmit}>
          <ProductVariantSelector
            attributes={this.props.attributes}
            handleProductChange={this.handleProductChange}
            productId={this.state.productId}
            getFieldDecorator={getFieldDecorator}
            form={this.props.form}
            allPhoneBrands={this.props.allPhoneBrands}
            phones={this.props.phones}
            loadPhonesByBrandIds={this.props.loadPhonesByBrandIds}
          />
          {this.state.productId !== 0 && (
            <React.Fragment>
              <h2 className="page-title">Status Information</h2>
              <Row gutter={24}>
                <Col sm={24} md={6}>
                  <Form.Item label="Enabled">
                    {getFieldDecorator('enabled', {
                      initialValue: true,
                      valuePropName: 'checked',
                      rules: [
                        {
                          required: true,
                          message: 'Required'
                        }
                      ]
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col sm={24} md={6}>
                  <Form.Item label="Stock Status">
                    {getFieldDecorator('stockStatus', {
                      rules: [
                        {
                          required: true,
                          message: 'Required'
                        }
                      ]
                    })(
                      <Select>
                        <Select.Option key="IN_STOCK">In Stock</Select.Option>
                        <Select.Option key="OUT_OF_STOCK">Out of Stock</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col sm={24} md={6}>
                  <Form.Item label="New To">
                    {getFieldDecorator('newTo', {
                      rules: [
                        {
                          required: false
                        }
                      ]
                    })(<DatePicker />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={24} md={8}>
                  <Form.Item label="Tag Option">
                    {getFieldDecorator('tag', {
                      rules: [
                        {
                          required: false
                        }
                      ]
                    })(<Autocomplete.ProductTag onChange={tag => (this.tagOption = tag)} />)}
                  </Form.Item>
                </Col>
                <Col sm={24} md={8}>
                  <Form.Item label="Tag Start Date">
                    {getFieldDecorator('tagStartDate', {
                      rules: [
                        {
                          required: this.tagOption,
                          message: 'Required'
                        }
                      ]
                    })(<DatePicker />)}
                  </Form.Item>
                </Col>
                <Col sm={24} md={8}>
                  <Form.Item label="Tag End Date">
                    {getFieldDecorator('tagEndDate', {
                      rules: [
                        {
                          required: false
                        }
                      ]
                    })(<DatePicker />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={24} md={12}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Update
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  loadAttrs: productActions.loadAttrs,
  findAllCustGrp: customerGroupActions.findAll,
  loadAllPhoneBrands: attributeActions.loadAllPhoneBrands,
  loadPhonesByBrandIds: attributeActions.loadPhonesByBrandIds,
  unloadProduct: productActions.unload,
  unloadCustGrp: customerGroupActions.unload,
  unloadAttrs: attributeActions.unload,
  countSelection: productVariantActions.countSelection,
  updateStatus: productVariantActions.updateBulkStatus,
  setMessages: homepageActions.setMessages
};

const mapStateToProps = (state, ownProps) => {
  return {
    attributes: productSelectors.getAttrs(state),
    allCustGrp: customerGroupSelector.getAllCustomerGrp(state),
    allPhoneBrands: attributeSelectors.getAllPhoneBrands(state),
    phones: attributeSelectors.getPhones(state),
    selectionCount: productVariantSelector.getSelectionCount(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withScreenLoader(withEventBus(Form.create({})(ProductStatusUpdate))));
